import { render } from "./CustomerAccommodationInquiriesView.vue?vue&type=template&id=cdd6deec&scoped=true&ts=true&lang=pug"
import script from "./CustomerAccommodationInquiriesView.vue?vue&type=script&lang=ts"
export * from "./CustomerAccommodationInquiriesView.vue?vue&type=script&lang=ts"

import "./CustomerAccommodationInquiriesView.vue?vue&type=style&index=0&id=cdd6deec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd6deec"]])

export default __exports__